import { dashboardStore } from 'store/DashboardStore';
import { passbookStore } from 'store/PassbookStore';
import { userStore } from 'store/UserStore';

/**
 * Get payment method label long term
 * @param method
 */
export const getPaymentMethodLabel = (method: string) => {
  switch (method) {
    case 'NEBK':
      return 'Net Banking';
    case 'UPI':
      return 'UPI';
    case 'RTGS':
      return 'RTGS';
    case 'TT':
      return 'Telegraphic Transfer';
    case 'NEFT':
      return 'NEFT';
    case 'IMPS':
      return 'IMPS';
    case 'BPY':
      return 'NEFT';
    case 'VA':
      return 'VA';
    default:
      return 'OTHER';
  }
};

/**
 * Get transaction long name
 * @param record
 */
export const getTransactionName = (record: any) => {
  if (record.type == 'ORDER_SELL' && record.method == 'WALLET') {
    return `Purchased ${record.metalName ? record.metalName : 'metal'}`;
  } else if (record.type == 'ORDER_SELL' && record.method == 'UPI') {
    return `Added wallet money via ${getPaymentMethodLabel(record.method)}`;
  } else if (record.type == 'ORDER_SELL' && record.method == 'NEBK') {
    return `Added wallet money via ${getPaymentMethodLabel(record.method)}`;
  }
  /// WALLET
  else if (
    (record.type == 'WALLET' && record.method == 'UPI') ||
    (record.type == 'WALLET' && record.method == 'NEBK') ||
    (record.type == 'WALLET' && record.method == 'VA')
  ) {
    return `Added wallet money via ${getPaymentMethodLabel(record.method)}`;
  } else if (
    record.type == 'ORDER_BUYBACK' &&
    record.method == 'VERIFICATION'
  ) {
    return 'Proceeds of Buyback remitted via NEFT';
  } else if (
    record.type == 'ORDER_BUYBACK' &&
    record.method == 'ORDER_REFUND'
  ) {
    return 'Refund';
  } else if (
    (record.type == 'ORDER_BUYBACK' && record.method == 'WALLET') ||
    (record.type == 'ORDER_BUYBACK' && record.method == 'IMPS')
  ) {
    return `Sold ${record.metalName ? record.metalName : 'metal'}`;
  } else if (
    record.type == 'WALLET' &&
    (record.method == 'IMPS' || record.method == 'RTGS')
  ) {
    return `Withdrawn money via ${getPaymentMethodLabel(record.method)}`;
  } else if (record.type == 'REWARD' && record.method == 'WALLET') {
    return `Rewarded money into Wallet`;
  } else if (record.type == 'CASHBACK' && record.method == 'WALLET') {
    if (record.extRefId) {
      return `Cashback Credited`;
    } else {
      return `Cashback Credited`;
    }
  } else {
    return (
      'Unknown : ' + record.type + ' ' + getPaymentMethodLabel(record.method)
    );
  }

  // console.log(transaction);
  // if (transaction.type == "ORDER_SELL") {
  //     if(transaction.method === 'WALLET'){
  //         return `Purchased metal`;
  //     }else {
  //         return `Added to wallet via ${getPaymentMethodLabel(transaction.method)}`;
  //     }
  // } else if (transaction.type == "ORDER_BUYBACK") {
  //     if(transaction.method === 'VERIFICATION'){
  //         return `Proceeds of buyback remitted via ${getPaymentMethodLabel(transaction.method)}`;
  //     }else{
  //         return `Sold metal`;
  //     }
  // } else if (transaction.type == "WALLET") {
  //     if(transaction.method === 'NEFT'){
  //         return `Withdrew Money via ${getPaymentMethodLabel(transaction.method)}`;
  //     }else{
  //         return `Added Money via ${getPaymentMethodLabel(transaction.method)}`;
  //     }
  // } else {
  //     return ``;
  // }
};

/**
 * Get transaction type
 * @param transaction
 */
export const getTransactionType = (transaction: any) => {
  // if (transaction?.meta?.payment?.request?.transactionMethod != null) {
  //   if (transaction?.meta?.payment?.request?.transactionMethod == 'NEBK') {
  //     return 'Net Banking';
  //   } else {
  //     return transaction?.meta?.payment?.request?.transactionMethod;
  //   }
  // } else {
  if (transaction?.order?.paymentMethod == 'NEBK') {
    return 'Net Banking';
  } else if (
    transaction?.order?.paymentMethod == 'IMPS' ||
    transaction?.order?.paymentMethod == 'RTGS'
  ) {
    return 'Bank Transfer';
  } else if (transaction?.order?.paymentMethod == 'WALLET_NEBK') {
    return 'WALLET + Net Banking';
  } else if (transaction?.order?.paymentMethod == 'WALLET_UPI') {
    return 'WALLET + UPI';
  } else if (transaction?.order?.paymentMethod == 'CUSTOMER_WALLET') {
    return 'WALLET';
  } else if (transaction?.order?.paymentMethod == 'CORP_GIFT') {
    return 'GIFT';
  } else if (transaction?.order?.paymentMethod == 'EMANDATE') {
    return 'AUTOPAY';
  } else {
    return transaction?.order?.paymentMethod;
  }
  // }
  // return 'WALLET';
  //PAY using emandate
  // return 'AUTOPAY';
};

/**
 * Format amount
 * @param amount
 * @param digits
 */
export const formatAmount = (amount: number, digits: number = 2) => {
  // console.log(amount);

  if (typeof amount !== 'number') {
    return;
  }
  if (!amount) return '0.00';
  let amountPieces = amount.toFixed(digits).toString().split('.');
  if (amountPieces.length === 0) return '0.00';
  return `${amountPieces[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${
    amountPieces[1]
  }`;
};


export const formatTime = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};


export const removeSeparator = (value: any) => {
  if (typeof value === 'string') {
    return Number(value.replace(/,/g, ''));
  } else {
    return value;
  }
};

export const addThousandSeparators = (amount: number) => {
  if (typeof amount !== 'number') {
    return;
  }
  if (!amount) return '0.00';
  let amountPieces = amount.toString().split('.');
  if (amountPieces.length === 0) return '0.00';
  if (amountPieces[1])
    return `${amountPieces[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${
      amountPieces[1]
    }`;
  return `${amountPieces[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
};

/**
 * Generate query parameters from an object
 * @param data
 */
export const makeQuery = (data: any) => {
  let query = '';
  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        query += `&${key}=${item}`;
      });
    } else {
      query += value === '' ? '' : `&${key}=${value}`;
    }
  });
  return query;
};



export const formatINR = (amount: number, isCurrency = true) => {
  return new Intl.NumberFormat('en-IN', {
    style: isCurrency ? 'currency' : 'decimal',
    currency: 'INR',
    minimumFractionDigits: isCurrency ? 2  : 4,
    maximumFractionDigits: isCurrency ? 2  : 4,
  }).format(amount);
};




export const clearSessionData = () => {
  userStore.setState({
    user: {},
    customer: {},
    customers: [],
    customerId: '',
    isAuthenticated: false,
    tokens: { accessToken: null, idToken: null },
    userData: {},
    selectedAccount: {},
  });
  passbookStore.setState({ metalTransactions: [], walletTransactions: [] });
  dashboardStore.setState({
    customerHolding: [],
    accountsHolding: [],
    wallet: {},
    summary: {},
    metals: [],
  });
  localStorage.clear();
  sessionStorage.clear();
};

export const padToTwo = (number) => {
  return ('00' + number).slice(-2);
};

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const getDocumentType = (userType) => {
  switch (userType) {
    case 'HUF':
      return {
        type: 'HUF Declaration Letter',
        description:
          'Declaration by Karta and all the coparceners to eBullion Private Limited',
      };
    case 'TRUST':
      return {
        type: 'Trust Authorization Letter',
        description:
          'Letter of authorization by the Trustees to eBullion Private Limited',
      };
    case 'CO':
    case 'LLP':
    default:
      return {
        type: 'Board Resolution',
        description: 'Board resolution signed by Authorized Signatory',
      };
  }
};
